import React, { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { CancelSmallMinor } from '@shopify/polaris-icons'

interface Props {
  title: string
  className?: any
  onClose(): void
  closeButtonTestId?: string
}

const ModalHeaderComponent = ({ title, className, onClose, closeButtonTestId }: Props) => {
  return (
    <div
      css={[
        tw`flex flex-row justify-between items-center p-2 pl-4 border-0 border-b border-solid  border-shades-100`,
        className,
      ]}
    >
      <Typography variant="h5">{title}</Typography>
      <div
        css={tw`p-1 justify-center items-center flex rounded bg-shades-100 h-10 w-10 lg:h-[28px] lg:w-[28px] hover:bg-shades-200 active:bg-shades-300 cursor-pointer`}
        onClick={onClose}
        {...(closeButtonTestId ? { 'data-testid': closeButtonTestId } : {})}
      >
        <CancelSmallMinor width={20} height={20} />
      </div>
    </div>
  )
}

export const ModalHeader = memo(ModalHeaderComponent)
